import { Box, IconOptions } from '@jfs/ui-new'
import { FC, ReactElement } from 'react'
import Tab, { TabState, TabType } from '../Tab'
import { TableComponent } from '../TableComponent'
import styles from './styles'
import type { TabbarProps, TabData } from './types'
import { TabbarType } from './types'

const keyExtractor = (item: TabData): string => {
  return item.title
}

const cellView = (
  {
    index,
    item,
  }: {
    index: number
    item: TabData
  },
  type: TabbarType,
  defaultIndex: number,
  onSelected: any,
  disabled: boolean,
  onLayout: any,
): ReactElement => {
  const titleText = item?.title ?? ''
  return (
    <Box {...styles[type].tab}>
      <Tab
        iconId={item.iconId as IconOptions}
        title={item.title}
        state={index === defaultIndex ? TabState.selected : TabState.normal}
        type={TabType[type]}
        onSelected={(): void => onSelected(index, titleText)}
        isDisabled={disabled}
        onLayout={onLayout}
      />
    </Box>
  )
}

const Tabbar: FC<TabbarProps> = ({
  titles,
  onSelected,
  default: defaultIndex = 1,
  type = TabbarType.default,
  hide = false,
  disabled = false,
  onLayout,
  onLayoutOnlyForPosition,
}: TabbarProps) => {
  const cellRenderor = ({ index, item }: { index: number; item: TabData }): ReactElement => {
    return cellView(
      { index, item },
      type,
      defaultIndex,
      onSelected,
      disabled,
      !onLayoutOnlyForPosition || onLayoutOnlyForPosition === index ? onLayout : undefined,
    )
  }

  const SeparatorComponent = () => {
    return <Box {...styles[type].seperator} />
  }

  const returnWrappingFlex = () => {
    if (type === TabbarType.recentPayments) {
      return 1
    }
  }

  const getOpacity = () => {
    return disabled ? { opacity: 0.4 } : {}
  }
  if (hide) {
    return null
  } else {
    return (
      <TableComponent
        value={''} //Routes value
        canFetchMore={false}
        ListContent={titles}
        hide={false}
        isCustom={true}
        horizontal
        flexForListContainer={returnWrappingFlex()}
        RenderCustomElement={cellRenderor}
        customStyle={[styles[type].container, getOpacity()]}
        ItemSeparatorComponent={SeparatorComponent}
        keyExtractor={keyExtractor}
        extraData={defaultIndex}
      />
    )
  }
}
export type { TabData }
export { TabbarType }
export default Tabbar
